import classNames from 'classnames';

import { NavLink } from 'react-router-dom';

import React from 'react';

import { useTranslation } from '~shared/lib/i18n';

import { RoutesUrls } from '~shared/lib/router';

import Logotype from '../assets/logo.svg';

import styles from './Logo.module.scss';

export interface LogoProps {
  collased?: boolean;
}

export const Logo = ({ collased = true, activeLink = true }) => {
  const { t } = useTranslation();
  const wrapperClass = classNames(styles.wrapper, !collased ? styles.closed : '');

  return (
    <NavLink to={activeLink ? RoutesUrls.parent : ''}>
      <div className={wrapperClass}>
        <img className={styles.logo} src={Logotype} alt="logo" />
        <h2 className={styles.title}>{t('appName')}</h2>
      </div>
    </NavLink>
  );
};
